import React from "react";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";
import Layout from "../layout";
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";
import "./index.css";
import "../css/global.css"

class Index extends React.Component {
  render() {
    const postEdges = this.props.data.allAirtable.edges;
    return (
      <Layout>
        <div className="index-container">
          <Helmet title={config.siteTitle} />
          <SEO />
          <div className="max-w-screen-md mx-auto px-8 text-xl py-16">
            <title> Sobbuh.com</title>
            <blockquote>
              {' '}
“A good project is born not from an ambition to leave a legacy, but from the will to initiate an exchange" <br/>
Achille Castiglioni 
            </blockquote>
            <p>
              Hi, my name is Sobbuh.  I guess you pronounce it se-boo, kinda. Who knows. It’s not a real name, and I won’t be upset if you get it wrong. On the plus side, I got my own domain name pretty easily.  
            </p>
            <p>  
              This is my home on the internet, and a collection of my thoughts - my opportunity to initiate an exchange. Everything here is a work in progress, and open to discussion.
            </p>
            <p>
              I’m positive about the world, the people who inhabit it, and our ability to make it even better. 
            </p>
            <p>
              If you're here, you should probably say hi. Twitter or email work well.
            </p>
            <h2> Recent thoughts </h2>
            <PostListing postEdges={postEdges} />
          </div>
        </div>
      </Layout>
    );
  }
}

export default Index;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query IndexQuery($dateFormat: String) {
    allAirtable(
      limit: 2000
      sort: {fields: data___date, order: DESC}
      filter: {data: {status: {eq: "publish"}}}
    ) {
      edges {
        node {
          data {
            slug
            date(formatString: $dateFormat)
            title
            tags
            category
            author {
              data { 
                name
                email
                twitter
              }
            }
            postMarkdown {
              childMarkdownRemark {
                html
                excerpt(format: PLAIN)
                timeToRead
              }
            }
            image {
              url
            }
          }
        }
      }
    }
  }
`;
